import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import API from '../../../api/api'
import { useSnackbar } from '../../../helpers/hooks/useSnackbar'

export const useAnalytics = (buildingId, period) => {
  const { t } = useTranslation(['visitors'])
  const { displaySnackbar } = useSnackbar()

  const [data, setData] = useState()
  const [isLoading, setIsLoading] = useState(false)

  const handleFetchData = async () => {
    try {
      setIsLoading(true)
      const result = await API.getVisitorAnalytics(buildingId, period)
      setData(result.data)
    } catch {
      displaySnackbar(t('visitors:snackbar.loadDataError', { period }), true)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (!buildingId || !period) {
      return
    }
    handleFetchData()
  }, [buildingId, period])

  return {
    data,
    isLoading,
  }
}
